import { makeStyles } from '@mui/styles';
import { CustomTheme } from 'types/theme';

export const useStyles = makeStyles((theme: CustomTheme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
    marginTop: 30
  },
  emailLabel: {
    '&.MuiTypography-root': {
      color: theme.palette.text.secondary,
      fontSize: 11,
      fontWeight: 700,
      lineHeight: '18px',
      letterSpacing: 0.5
    }
  },
  email: {
    '&.MuiTypography-root': {
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: 0.15
    }
  },
  stepsContainer: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textStepBack: {
    '&.MuiTypography-root': {
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '24px',
      letterSpacing: 0.4,
      cursor: 'pointer'
    }
  },
  button: {
    height: '40px'
  },
  textExample: {
    '&.MuiTypography-root': {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '20px',
      letterSpacing: 0.4,
      color: 'rgba(0, 0, 0, 0.6)'
    }
  },
  count: {
    '&.MuiTypography-root': {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '20px',
      letterSpacing: 0.4,
      color: 'rgba(0, 0, 0, 0.6)',
      textAlign: 'end'
    }
  },
  containerBox: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px'
  },
  company: {
    '&.MuiTypography-root': {
      fontWeight: 700,
      fontSize: 16,
      color: 'rgba(0, 0, 0, 0.87)',
      marginBottom: '5px',
      marginLeft: '22px'
    }
  },
  informations: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    marginBottom: '2px',
    padding: '2px 22px'
  },
  valuesInformations: {
    '&.MuiTypography-root': {
      color: 'rgba(0, 0, 0, 0.6)',
      fontSize: 14,
      fontWeight: 400
    }
  },
  icon: {
    width: '10px',
    color: '#9a9999'
  },
  input: {
    display: 'none'
  },
  image: {
    width: '38px',
    height: '38px',
    borderRadius: 64,
    marginTop: '-19px',
    marginLeft: '22px'
  },
  imageIcon: {
    width: '38px',
    height: '38px',
    borderRadius: 64,
    marginTop: '-19px',
    marginLeft: '22px',
    backgroundColor: 'rgba(221, 221, 221, 1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '15px',
    position: 'relative'
  },
  grayDiv: {
    height: '62px',
    backgroundColor: 'rgba(189, 189, 189, 1)',
    width: '100%'
  },
  slogan: {
    '&.MuiTypography-root': {
      marginLeft: '22px',
      marginBottom: '5px',
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: 13,
      color: 'rgba(0, 0, 0, 0.38)'
    }
  }
}));
